import moment from "moment";

export function checkBetweenDates(startDate, endDate, dateToCheck) {
    return moment(dateToCheck, "YYYY-MM-DD").isBefore(moment(endDate, "YYYY-MM-DD"))
        && moment(dateToCheck, "YYYY-MM-DD").isSameOrAfter(moment(startDate, "YYYY-MM-DD"));
}

export function getDateStringNow(format) {
    return moment(new Date(), format);
}

/**
 * get diff entre 2 dateString as nb day
 * 
 * @param {*} dateDebut 
 * @param {*} dateFin 
 * @returns {int}
 */
export function getDateEcart(dateDebut, dateFin) {
    const duration = moment.duration(moment(dateFin).diff(moment(dateDebut)));
    
    return duration.asDays();
}


/**
 * 
 * @param {Date} date 
 * @param {String} format //def 'YYYY-MM-DD' 
 * @returns {String}
 */
export function formatDateToString(date, format='YYYY-MM-DD') {
    return moment(date).format(format);
}